import { ArrowRight, ChefHat } from "lucide-react";
import { Link } from "react-router-dom";
import { useCustomizer } from "../../context/CustomizerContext";
import { builderStartingPrice } from "../../utils/builder";
import { formatPrice } from "../../utils/format";
import { Reveal } from "../ui/Reveal";

/** Chamada para o "Monte seu Lanche" (só aparece se ele estiver disponível). */
export const BuilderBanner = ({ className }: { className?: string }) => {
  const { builder } = useCustomizer();
  if (!builder) return null;

  return (
    <Reveal className={className}>
      <Link
        to="/monte-seu-lanche"
        className="group relative flex flex-col gap-5 overflow-hidden rounded-card border border-primary/30 bg-gradient-to-r from-primary/15 via-card to-card p-6 transition-colors hover:border-primary/60 sm:flex-row sm:items-center sm:justify-between sm:p-8"
      >
        <span className="flex items-center gap-5">
          <span className="grid size-14 shrink-0 place-items-center rounded-2xl bg-primary text-night transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105">
            <ChefHat className="size-7" aria-hidden="true" />
          </span>
          <span>
            <span className="block font-display text-3xl leading-none tracking-wide sm:text-4xl">
              Monte seu <span className="text-primary">lanche</span>
            </span>
            <span className="mt-1.5 block text-sm text-muted">
              Escolha pão, carne, queijo, salada e molho — do zero, do seu jeito. A partir de{" "}
              <strong className="text-white">{formatPrice(builderStartingPrice(builder))}</strong>.
            </span>
          </span>
        </span>
        <span className="inline-flex h-11 shrink-0 items-center justify-center gap-2 self-start rounded-full bg-primary px-6 text-sm font-semibold text-night transition-colors group-hover:bg-primary-hover sm:self-auto">
          Montar agora <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
        </span>
      </Link>
    </Reveal>
  );
};
